<div class="cm-modal-overlay" id="onboardingModal">
    <div class="cm-modal-container">
        <div class="cm-modal-header">
            <div>
                <h2>Tutorials on YouTube</h2>
                <p>Get up and running quickly with these essential guides.</p>
            </div>
            <button class="cm-close-btn" aria-label="Close dialog" (click)="onClose()">&times;</button>
        </div>

        <div class="cm-video-grid">
            <a href="https://www.youtube.com/playlist?list=PLcV4dsNvt_l8" target="_blank" rel="noopener" class="cm-video-card">
                <div class="cm-thumbnail-wrapper">
                    <img src="assets/images/texture-editor.jpg" alt="Tile a Texture" />
                    <div class="cm-play-overlay">
                        <i class="fas fa-play cm-video-play"></i>
                    </div>
                </div>
                <h3>Tile a Texture</h3>
            </a>

            <a href="https://www.youtube.com/playlist?list=PLeYcGka-ZS00" target="_blank" rel="noopener" class="cm-video-card">
                <div class="cm-thumbnail-wrapper">
                    <img src="assets/images/configurator.png" alt="Create a Configurator" />
                    <div class="cm-play-overlay">
                        <i class="fas fa-play cm-video-play"></i>
                    </div>
                </div>
                <h3>Create a Configurator</h3>
            </a>

            <!-- Without a href the tile stays in the grid but isn't a link until the add-on URL has loaded. -->
            <a
                [attr.href]="$blenderAddonDownload()?.url ?? null"
                target="_blank"
                rel="noopener"
                class="cm-video-card"
                [class.cm-video-card-unavailable]="!$blenderAddonDownload()"
            >
                <div class="cm-thumbnail-wrapper">
                    <img src="assets/images/download-blender-plugin.png" alt="Download Blender Plugin" />
                    <div class="cm-play-overlay">
                        <i class="fas fa-arrow-down-to-line cm-video-play"></i>
                    </div>
                </div>
                <h3>Download Blender Plugin</h3>
            </a>

            <a
                href="https://docs.colormass.com/building-blocks/materials/add-a-material/upload-image-as-a-material-ai"
                target="_blank"
                rel="noopener"
                class="cm-video-card"
            >
                <div class="cm-thumbnail-wrapper">
                    <img src="assets/images/material-ai.png" alt="Create a Material with AI" />
                    <div class="cm-play-overlay">
                        <i class="fas fa-link cm-video-play"></i>
                    </div>
                </div>
                <h3>Create Materials with AI</h3>
            </a>

            <a href="https://discord.gg/eMN96WkUvx" target="_blank" rel="noopener" class="cm-video-card-2">
                <i class="fa-brands fa-discord cm-discord-icon"></i>
                <div>
                    <span class="cm-discord-invite-title">Can't find the feature or download you are looking for?</span> Join our Discord and request a feature
                    or a sample to be scanned. <span class="cm-discord-join">Join <i class="far fa-arrow-right"></i></span>
                </div>
            </a>
        </div>

        <div class="cm-modal-footer">
            <div class="cm-checkbox-group">
                <input type="checkbox" id="hideForever" [checked]="$dontShowAgain()" (change)="$dontShowAgain.set($any($event.target).checked)" />
                <label for="hideForever">Don't show this again</label>
            </div>
            <button class="cm-btn-primary" (click)="onHide()">Hide</button>
        </div>
    </div>
</div>
